import React from "react";
import { Link } from "react-router-dom";
import AISecurityArticle from "../components/AISecurityArticle";
import { usePageTitle } from "../hooks/usePageTitle";

function AISecurityPage() {
  usePageTitle("Sécurité et IA");
  return (
    <div className="terraform-page">
      <Link to="/blog" className="article-back-btn">← Blog</Link>
      <AISecurityArticle />
    </div>
  );
}

export default AISecurityPage;
